import http from "./request";

/**************************** feature_KAD-1132 start *********************************/
// 身份验证
export const checkAuth = params => {
  return http.fetchPost("/fyapi/v1/fyapi/bankH5/bankTheLogin", params);
};

// 申请贷款列表
export const applyList = params => {
  return http.fetchPost("/fyapi/v1/fyapi/bankH5/listLoansOrder", params);
};

// 申请贷款详情  POST /v1/fyapi/bankH5/getLoansOrderInfo
export const applyDetail = params => {
  return http.fetchPost("/fyapi/v1/fyapi/bankH5/getLoansOrderInfo", params);
};

// 申请贷款详情  POST /v1/fyapi/bankH5/getLoansOrderInfo
export const updateOrderStatus = params => {
  return http.fetchPost("/fyapi/v1/fyapi/bankH5/updateOrderStatus", params);
};

// 发送验证码
export const sendSms = params => {
  return http.fetchPost(
    "/fyapi/v1/fyapi/mortgageTransfer/getVerificationCode",
    params
  );
};
// 登录
export const customerAuth = params => {
  return http.fetchPost("/fyapi/v1/fyapi/mortgageTransfer/auth", params);
};

// 交易流程列表查询
export const transferList = params => {
  return http.fetchPost(
    "/fyapi/v1/fyapi/mortgageTransfer/subscribeOrderList",
    params
  );
};

// 交易流程详情
export const transferDetail = params => {
  return http.fetchPost(
    "/fyapi/v1/fyapi/mortgageTransfer/subscribeOrderInfo",
    params
  );
};

// 交易流程列表查询
export const saveComment = params => {
  return http.fetchPost(
    "/fyapi/v1/fyapi/mortgageTransfer/addTransactionFlowEvaluation",
    params
  );
};
